import * as React from 'react';
import { withMetroLine } from 'app/components/metro-line/with-metro-line';
import { WithMetroLineWrappedComponentProps } from 'app/components/metro-line/types';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { SubscriberGroupSectionType } from '../metroline/types';
import { SubscriberGroupFormProps } from '../types';
import { SubscriberGroupContainer } from './subscriber-group-container';
import { SubscriberGroupDetailsContainer } from './subscriber-group-details';
import { SubscriberGroupLanguage } from './subscriber-group-language';
import { ExternalMembersContainer } from 'app/area/subscriber-groups/form/components/external-members-container';
import { UserMembersContainer } from 'app/area/subscriber-groups/form/components/user-members-container';
import { replaceTemplateString } from 'app/infrastructure/platform';

const SubscriberGroupFormRendererContainer: React.FC<SubscriberGroupFormProps
  & WithMetroLineWrappedComponentProps<SubscriberGroupSectionType>> = ({
    locale, translation, section, options, shouldPrompt,
    actionType, formState, mainLanguage, showTranslations,
    switchTranslationsToggle, saveSubscriberGroup, updateItem,
    changeLanguage, copyLanguageToAll, changeLongDescription, copyLongDescriptionToAll,
    updateValidation, displayError, getRef, shouldRenderSection,
    updateExternalMemberItem, removeExternalMember, addExternalMember,
    resetValidation, removeAllExternalMembers, mergeSubscriberGroupItem
  }) => {

    const { subscriberGroupItem, languageOptions, validation } = formState;

    const panelProps = {
      actionType,
      subscriberGroupItem,
      options,
      locale,
      validation,
      translation,
      section,
      updateExternalMemberItem,
      removeExternalMember,
      addExternalMember,
      resetValidation,
      removeAllExternalMembers,
      getRef,
      shouldRenderSection,
      updateItem,
      updateValidation,
      displayError
    };

    const renderLanguageOnTop = !isDefinedIncludingZero(subscriberGroupItem?.id);
    const languageSection = <SubscriberGroupLanguage
      language={subscriberGroupItem?.language}
      longDescription={subscriberGroupItem?.longDescription}
      mainLanguage={mainLanguage}
      languageOptions={languageOptions}
      changeLanguage={changeLanguage}
      copyLanguageToAll={copyLanguageToAll}
      changeLongDescription={changeLongDescription}
      copyLongDescriptionToAll={copyLongDescriptionToAll}
      requiredLongDescription={formState.subscriberGroupItem.selfService}
      showTranslations={showTranslations}
      switchTranslationsToggle={switchTranslationsToggle}
      validation={validation}
      translation={translation}
      section={section}
      getRef={getRef}
      shouldRenderSection={shouldRenderSection} />;

    const currentDescription = formState.subscriberGroupItem.language.find(item => item.value === mainLanguage)?.description;
    const userMembersInfoText = !!currentDescription
      ? replaceTemplateString(translation.user_members_info_with_description, currentDescription)
      : translation.user_members_info_no_description;

    const detaulsInfoText = !!currentDescription
      ? replaceTemplateString(translation.external_members_info_with_description, currentDescription)
      : translation.external_members_info_no_description;

    return <SubscriberGroupContainer
      actionType={actionType}
      formState={formState}
      shouldPrompt={shouldPrompt}
      mainLanguage={mainLanguage}
      switchTranslationsToggle={switchTranslationsToggle}
      saveSubscriberGroup={saveSubscriberGroup}
      mergeSubscriberGroupItem={mergeSubscriberGroupItem}
      updateValidation={updateValidation}
      displayError={displayError}
      validation={validation}
      translation={translation}>
      {renderLanguageOnTop && languageSection}
      <SubscriberGroupDetailsContainer {...panelProps} />
      <UserMembersContainer
        subscriberGroupId={formState.originalSubscriberGroupItem?.id}
        locale={locale}
        translation={translation}
        section={section}
        infoText={userMembersInfoText}
        getRef={getRef}
        displayError={displayError}
        shouldRenderSection={shouldRenderSection}
      />
      <ExternalMembersContainer {...panelProps} infoText={detaulsInfoText} />
      {!renderLanguageOnTop && languageSection}
    </SubscriberGroupContainer>;
  };

export const SubscriberGroupsFormRenderer = withMetroLine<SubscriberGroupFormProps,
  SubscriberGroupSectionType>()(SubscriberGroupFormRendererContainer);
